(function (ws) {
    'use strict';

    ws.views.quoteTableListPriceCostView = ws.views.modal.extend({
        /**
         * Extend default events
         */
        events: _.extend({}, ws.views.modal.prototype.events, {
            'click .qut-table-update-listPriceCost:not(:disabled)': 'getUpdatedModelBasedOnSite',
            'keyup .qut-listPrice-cost': 'enableUpdateButton'
        }),

        /**
         * Initialize
         */
        initialize: function () {
            ws.views.modal.prototype.initialize.call(this);
            this.eventAgg.on('renderListPriceCostOverlay', this.renderListPriceCostOverlay, this);
            this.eventAgg.on('updateListPriceCost', this.updateListPriceCost, this);
            this.eventAgg.on('revertUpdatedColumn', this.revertUpdatedColumn, this);
        },

        /**
         * Enable Update Button
         * @param {Event} e
         */
        enableUpdateButton: function (e) {
            if ($.isNumeric(e.currentTarget.value)) {
                this.$('.qut-table-update-listPriceCost').prop('disabled', false);
            } else {
                this.$('.qut-table-update-listPriceCost').prop('disabled', true);
            }
        },

        /**
         * Render List Price Cost data in modal
         * @param {string} editedCol
         * @param {Model} model
         * @param {string} site
         */
        renderListPriceCostOverlay: function(editedCol, model, site) {
            var updateColumn = this.getUpdateColumnName(editedCol);

            this.eventAgg.trigger(this.$el.attr('id'));
            this.$button = this.$('.qut-table-update-listPriceCost');
            this.$button.attr('data-row', model.id);
            this.$button.attr('data-col', updateColumn);
            this.$button.attr('data-site', site);
            this.$('.qut-listPrice-cost-heading').html('Part Number: <b>' + model.partNo + '</b>');
            this.$('.qut-listPrice-cost-col-title').text(this.$('.title-' + site + '-' + updateColumn).text());
            this.$('.qut-table-update-listPriceCost').prop('disabled', true);
            this.$('.qut-listPrice-cost').val('');
        },

        /**
         * This method will return which column needs to update.
         * @param {string} editedCol
         * @returns {string}
         */
        getUpdateColumnName: function (editedCol) {
            var updateColumn = '';
            if (editedCol === 'listPrice') {
                updateColumn = 'purchasePrice';
            } else if (editedCol === 'purchasePrice') {
                updateColumn = 'listPrice';
            }

            return updateColumn;
        },

        /**
         * Trigger update to product in table
         * @param {Event} e
         */
        getUpdatedModelBasedOnSite: function(e) {
            e.preventDefault(); //prevent form from submitting
            var updatedValue = {
                row: (e.target.dataset.row),
                col: e.target.dataset.col,
                val: this.$('.qut-listPrice-cost').val(),
                trigger: 'updateListPriceCost'
            };

            var triggerName = e.target.dataset.site + ':getUpdatedModel';
            this.eventAgg.trigger(triggerName, updatedValue);
            this.onClose(e);
        },

        /**
         * This method will update listPriceCost in the model
         * @param {Model} model
         * @param {{row: number, col: number, val: number, trigger: string}} updatedValue
         */
        updateListPriceCost: function (model, updatedValue) {
            model.set({listPriceCost: true}, {silent: true});
            if (updatedValue.col === 'listPrice') {
                model.set({listPrice: updatedValue.val});
            } else if (updatedValue.col === 'purchasePrice') {
                model.set({purchasePrice: updatedValue.val});
            }
        },

        /**
         * On cancel revere the updated field value
         * @param {Event} e
         */
        closeModal: function (e) {
            e.preventDefault(); //prevent form from submitting
            if (!$(e.currentTarget).hasClass('qut-table-update-listPriceCost')) {
                var $updateButton = this.$('.qut-table-update-listPriceCost')[0];
                var updatedValue = {
                    row: ($updateButton.dataset.row - 1),
                    col: this.getUpdateColumnName($updateButton.dataset.col),
                    trigger: 'revertUpdatedColumn'
                };
                var triggerName = $updateButton.dataset.site + ':getUpdatedModel';
                this.eventAgg.trigger(triggerName, updatedValue);
            }

            // Trigger super closeModal
            ws.views.modal.prototype.closeModal.call(this);
        },

        /**
         * Revert value of updated column.
         * @param {Object} model
         * @param {Object} updatedValue
         */
        revertUpdatedColumn: function (model, updatedValue) {
            const previousVal = model.previous(updatedValue.col);
            if (updatedValue.col === 'listPrice') {
                model.set({listPrice: previousVal}, {silent: true});
            } else if (updatedValue.col === 'purchasePrice') {
                model.set({purchasePrice: previousVal}, {silent: true});
            }
        }
    });
})(westcon);
